exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-center[data-v-356add01]{display:flex;flex-direction:column;align-items:center;justify-content:center}.position-ref[data-v-356add01]{position:relative}.full-width[data-v-356add01]{width:100%}.screen-height[data-v-356add01]{height:100vh}.code[data-v-356add01]{border-right:2px solid;font-size:26px;padding:0 15px}.code[data-v-356add01],.message[data-v-356add01]{text-align:center}.message[data-v-356add01]{font-size:18px;padding:10px}.list[data-v-356add01]{display:flex;list-style:none;padding-left:0;margin-bottom:0}.list__item[data-v-356add01]{margin-left:5px;margin-right:5px}", ""]);

// exports
